import MenuTileList from './MenuTileList';

export default MenuTileList;
